<template>
  <div id="staffForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-select label="Base Location" v-model="selectedCenterId" :items="availableCenters" item-text="name" item-value="id"/>
      <v-select v-if="contactTypes && contactTypes.length > 1" label="Type" v-model="selectedTypeId" :items="contactTypes" item-text="name" item-value="id"/>
      <v-text-field
        v-model="staff.firstName"
        label="First Name"
        :required="true"
      />
      <v-text-field
        v-model="staff.lastName"
        label="Last Name"
        :required="true"
      />
      <v-text-field
        v-model="staff.jobTitle"
        label="Job Title"
        :required="false"
      />
      <v-text-field
        v-model="staff.email"
        label="Email"
        :required="false"
        :rules="[rules.emailMatch]"
      />
      <v-text-field
        v-model="staff.phone"
        label="Phone"
        :required="false"
        v-mask="'(###) ###-####'"
      />

      <date-picker
        label="Date of Birth"
        :show-icon="false"
        v-model="staff.dob"
        :defaultNowOnNull="false"
        clearable
      />

      <v-select
        v-model="staff.gender"
        :items="staff.relations.gender"
        label="Gender"
        chips
        deletable-chips
      ></v-select>

      <v-textarea
        v-model="staff.about"
        label="About Staff"
        :required="false"
        outlined
      />

      <v-switch v-model="staff.active" label="Active"/>

      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import { getStaff } from "@/services/staff";
import { getAllContactTypes } from "@/services/contactType";
import { rules } from "@/store/util/rules.js";

import { mapActions } from "vuex";
import {mask} from 'vue-the-mask'

export default {
  props: ["id"],
  directives: {mask},
  data() {
    return {
      loaded: false,
      valid: false,
      contactTypes: [],
      selectedCenterId: null,
      selectedTypeId: null,
      staff: {
        relations: {
          gender: ["Female", "Male"],
        },
        firstName: "",
        lastName: "",
        jobTitle: null,
        gender: "",
        dob: "",
        email: null,
        phone: null,
        active: null,
        about: null,
        contactId: null,
        centerId: null,
        contactTypeId: null,
      },
      rules
    };
  },
  created() {
    this.setInstance();
  },
  computed: {
    ...mapGetters("auth", ["myCenters"]),
    ...mapGetters("navigation", ["globalCenter"]),
    availableCenters(){
      if(this.myCenters && this.myCenters.length > 0){
        return this.myCenters.filter(c => c.id != null);
      }
      else{ return [] }
    }
  },
  methods: {
    ...mapActions("staff", ["createStaff", "updateStaff"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),

    async handleSubmit() {
      this.staff.centerId = this.selectedCenterId;
      this.staff.contactTypeId = this.selectedTypeId;
      let staff = Object.assign({}, this.staff);
      delete staff.relations;

      staff.phone = this.formatPhoneNumber(this.staff.phone);
      staff.altPhone = this.formatPhoneNumber(this.staff.altPhone);

      if (this.id) {
        this.updateStaff(staff)
          .then(response => {
            console.log(response);
            this.addSuccessMessage("staff was updated successfully");
            this.$router.push({name: 'staffView', params: {id: this.id}})
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating staff, please try again later"
            );
          });
      } else {
        if(!staff.contactTypeId && this.contactTypes.length > 0){
          staff.contactTypeId = this.contactTypes[0].id;
        }

        this.createStaff(staff)
          .then(response => {
            const newStaff = response;
            this.addSuccessMessage("staff was created successfully");
            this.$router.push({name: 'staffView', params: {id: newStaff.id}})
          })
          .catch((error) => {
            this.addErrorMessage(error.data.message ||
              "Error creating staff, please try again later"
            );
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    formatPhoneNumber(phone){
      if(phone){
        return phone.trim().replace(/\D/g,'');
      }
      else{ return null; }
    },
    setInstance() {
      if (this.id) {
        this.staff.id = this.id;
        getStaff(this.id).then(response => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.staff, property)
            ) {
              this.staff[property] = instance[property];
            }
          }

          this.selectedCenterId = this.staff.centerId;
          this.selectedTypeId = this.staff.contactTypeId;
          this.loaded = true;

          this.$emit('input', this.staff)
        });
      } else {
        //set selected Center
        if(this.globalCenter){
          this.selectedCenterId = this.globalCenter.id;
        }
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {
      const params_target = {
        page: 0,
        size: 100
      };
      getAllContactTypes(params_target).then(response => {
        const allTypes = response.data.content;
        //filter all contact type that is staff
        this.contactTypes = allTypes.filter(type => type.is_staff);
      });
      
    }
  },
  components: {
  }
};
</script>
